import { useDisconnect } from "wagmi";
var projectId = "".concat(process.env.REACT_APP_WALLETCONNECT_PROJECT_ID);
export var useWalletCleanup = function () {
    var disconnect = useDisconnect().disconnect;
    var cleanup = function () {
        disconnect();
        localStorage.removeItem("wagmi.wallet");
        localStorage.removeItem("walletconnect:".concat(projectId));
        localStorage.removeItem("walletconnect");
    };
    return cleanup;
};
